import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import { fetchSizeMeasurementMaster } from '../sizeMeasurementMaster/sizeMeasurementMaster.actions';
import {
    CREATE_SIZE_MEASUREMENT_DETAILS_FORM,
    COPY_FOR_ALL_SIZES_VAR,
    ALL_SIZES_LOADING,
    FETCH_SIZE_MEASUREMENT_DETAILS_REQUEST,
    FETCH_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    FETCH_SIZE_MEASUREMENT_DETAILS_FAILURE,
    CREATE_SIZE_MEASUREMENT_DETAILS_REQUEST,
    CREATE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    CREATE_SIZE_MEASUREMENT_DETAILS_FAILURE,
    RESET_SIZE_MEASUREMENT_DETAILS_INFO,
    FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_REQUEST,
    FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_FAILURE,
    UPDATE_SIZE_MEASUREMENT_DETAILS_REQUEST,
    UPDATE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    UPDATE_SIZE_MEASUREMENT_DETAILS_FAILURE,
    DELETE_SIZE_MEASUREMENT_DETAILS_REQUEST,
    DELETE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
    DELETE_SIZE_MEASUREMENT_DETAILS_FAILURE,
    FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_REQUEST,
    FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_SUCCESS,
    FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_FAILURE,
    FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_REQUEST,
    FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_FAILURE
} from './sizeMeasurementDetails.actionsType';

// FETCH SIZE MEASUREMENT DETAILS DATA
export let fetchSizeMeasurementDetailsDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.sizeMeasurementDetailGET_SINGLE_USER_ID}/${id}`,
        responseTypeRequest: FETCH_SIZE_MEASUREMENT_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SIZE_MEASUREMENT_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SIZE_MEASUREMENT_DETAILS_FAILURE
    };
    return axiosCall(config);
};

// FETCH SIZE MEASUREMENT DETAILS DATA
export let fetchSizeMeasurementDetailsWithoutId = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.sizeMeasurementDetailGET}`,
        responseTypeRequest: FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_REQUEST,
        responseTypeSuccess: FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_SUCCESS,
        responseTypeFailure: FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_FAILURE
    };
    return axiosCall(config);
};

// CREATE SIZE MEASUREMENT DETAILS FORM
export let createSizeMeasurementDetailsForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_SIZE_MEASUREMENT_DETAILS_FORM, payload: { key, value } });
    };
};

// COPY FOR ALL_SIZES_LOADING
export let allSizesLoading = (data) => {
    return (dispatch) => {
        dispatch({ type: ALL_SIZES_LOADING, payload: data });
    };
};

// OPEN COPY FOR ALL SIZES MODAL
export let allSizesModal = (data) => {
    return (dispatch) => {
        dispatch({ type: COPY_FOR_ALL_SIZES_VAR, payload: data });
    };
};

// CREATE SIZE MEASUREMENT DETAILS
export let createSizeMeasurementDetails = (formData, modalClose, id) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        fldCreatedBy: 0,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        ...formData,
        fldFKSizeMeasurementHeader: parseInt(formData.fldFKSizeMeasurementHeader),
        fldFkPart: parseInt(formData.fldFkPart),
        fldFkMeasurment: parseInt(formData.fldFkMeasurment),
        fldSerialNumber: parseInt(formData.fldSerialNumber),
        fldSize: formData.fldSize.split('.').length >= 2 ? parseFloat(formData.fldSize) : parseInt(formData.fldSize),
        fldIncrement: formData.fldIncrement
            ? formData.fldIncrement.split('.').length >= 2
                ? parseFloat(formData.fldIncrement)
                : parseInt(formData.fldIncrement)
            : 0
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.sizeMeasurementDetailsPOST}`,
        responseTypeRequest: CREATE_SIZE_MEASUREMENT_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_SIZE_MEASUREMENT_DETAILS_FAILURE,
        resetFormData: RESET_SIZE_MEASUREMENT_DETAILS_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSizeMeasurementDetailsDetails(id)
    };
    return axiosCall(config);
};

export let createSizeMeasurementDetailsBulk = (data, id) => {
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.sizeMeasurementDetailsPOST_BULK}`,
        responseTypeRequest: CREATE_SIZE_MEASUREMENT_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_SIZE_MEASUREMENT_DETAILS_FAILURE,
        resetFormData: RESET_SIZE_MEASUREMENT_DETAILS_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: allSizesModal(false),
        singlApiArray: [fetchSizeMeasurementDetailsDetails(id)]
    };
    return axiosCall(config);
};

export let updateMeasurementDetailsBulk = (data, id) => {
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.sizeMeasurementDetailsPATCH_BULK}`,
        responseTypeRequest: CREATE_SIZE_MEASUREMENT_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_SIZE_MEASUREMENT_DETAILS_FAILURE,
        resetFormData: RESET_SIZE_MEASUREMENT_DETAILS_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: allSizesModal(false),
        singlApiArray: [fetchSizeMeasurementDetailsDetails(id)]
    };
    return axiosCall(config);
};

// GET SINGLE SIZE MEASUREMENT DETAILS
export let getSingleSizeMeasurementDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.sizeMeasurementDetailsGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_FAILURE,
        singlApiArray: [
            fetchPropertyDataForSizeDetailsMaster(22), // Measurement
            fetchPropertyDataForSizeDetailsMaster(21), // Part
            fetchSizeMeasurementMaster()
        ]
    };
    return axiosCall(config);
};

//UPDATE SIZE MEASUREMENT DETAILS
export let updateSizeMeasurementDetails = (formData, id, type) => {
    let today = new Date();
    let data = {
        ...formData,
        fldFKSizeMeasurementHeader: parseInt(formData.fldFKSizeMeasurementHeader),
        fldFkPart: parseInt(formData.fldFkPart),
        fldFkMeasurment: parseInt(formData.fldFkMeasurment),
        fldSerialNumber: parseInt(formData.fldSerialNumber),
        fldSize: formData.fldSize.split('.').length >= 2 ? parseFloat(formData.fldSize) : parseInt(formData.fldSize),
        fldIncrement: formData.fldIncrement
            ? formData?.fldIncrement.toString().split('.').length >= 2
                ? parseFloat(formData.fldIncrement)
                : parseInt(formData.fldIncrement)
            : 0,
        fldModifiedDt: today.toISOString(),
        fldModifiedBy: 1
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.sizeMeasurementDetailsPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_SIZE_MEASUREMENT_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_SIZE_MEASUREMENT_DETAILS_FAILURE,
        resetFormData: RESET_SIZE_MEASUREMENT_DETAILS_INFO,
        modalClose: type,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSizeMeasurementDetailsDetails(id)
    };
    return axiosCall(config);
};

// DELETE SIZE MEASUREMENT DETAILS
export let deleteSizeMeasurementDetails = (id, singleDataId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.sizeMeasurementDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_SIZE_MEASUREMENT_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_SIZE_MEASUREMENT_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_SIZE_MEASUREMENT_DETAILS_FAILURE,
        resetFormData: RESET_SIZE_MEASUREMENT_DETAILS_INFO,
        modalClose: true,
        getAllData: fetchSizeMeasurementDetailsDetails(singleDataId)
    };
    return axiosCall(config);
};

export let fetchPropertyDataForSizeDetailsMaster = (propertyId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${propertyId}`,
        responseTypeRequest: FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_REQUEST,
        responseTypeSuccess: FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_SUCCESS,
        responseTypeFailure: FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_FAILURE,
        payload: propertyId
    };
    return axiosCall(config);
};
